import { FrontTable } from '@/lib';
import { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getCSVTableColumns } from './helpers';
import { useAppDispatch, useAppSelector } from '@/reducers';
import { updateFileData } from '@/features/fileUploading/fileUploadingSlice';

type CSVTableProps = {
  fileContent: string[][];
  isDefaultHeaderCorrect: boolean;
  fileHeaders?: string[];
};
export const CSVTable: FC<CSVTableProps> = ({ fileHeaders, fileContent, isDefaultHeaderCorrect }) => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const csvFileData = useAppSelector((state) => state.fileUploading.fileData);

  const [tableContent, setTableContent] = useState<string[][]>([]);

  useEffect(() => {
    if (fileContent) {
      if (isDefaultHeaderCorrect) {
        setTableContent(fileContent.filter((_, i) => i > 0));

        dispatch(updateFileData({ preview: fileContent, header: fileContent[0], isDefaultHeader: isDefaultHeaderCorrect }));
      } else {
        if (csvFileData) {
          setTableContent(fileContent.filter((_, i) => i >= 0));

          const columnHeader = csvFileData.header.map((_, index) => `${t('data_source_edit:file.header.column')} ${index + 1}`);
          dispatch(updateFileData({ preview: fileContent, header: columnHeader, isDefaultHeader: isDefaultHeaderCorrect }));
        }
      }
    }
  }, [fileContent, isDefaultHeaderCorrect]);

  const tableData = useMemo(() => {
    return tableContent.map((row) => {
      const rowObject: Record<string, any> = {};
      row.forEach((cell, index) => {
        rowObject[`col_${index}`] = cell;
      });
      return rowObject;
    });
  }, [tableContent]);

  const columns = useMemo(() => {
    if (!fileHeaders.length || !fileContent.length) return [];

    return getCSVTableColumns({
      t,
      headers: fileHeaders,
      fileContent,
      isDefaultHeaderCorrect,
    });
  }, [t, fileHeaders, fileContent, isDefaultHeaderCorrect]);

  return <FrontTable innerWrapperClassName='pb-0' tableData={tableData} columns={columns} />;
};
